import { mapValues } from 'lodash'

let interactiveMark = 0
const MAX_TIME = 5000

export function setInteractiveMark() {
  if ('performance' in window) {
    requestAnimationFrame(() => {
      interactiveMark = interactiveMark || performance.now()
    })
  }
}

export const navTimingReady = new Promise((resolve, reject) => {
  try {
    if ('performance' in window && 'PerformanceObserver' in window) {
      const observer = new PerformanceObserver(resolve)
      observer.observe({ entryTypes: ['navigation'] })
    }
    setTimeout(resolve, MAX_TIME)
  } catch (e) {
    resolve()
  }
})

export function getPerformanceTimings() {
  return 'performance' in window ? timingFromLegacyApi() : {}
}

function timingFromLegacyApi() {
  const timing: any = performance.timing || {}
  const interactiveTime = timing.navigationStart + interactiveMark
  return mapValues(
    {
      ttfb: timing.responseEnd - timing.navigationStart,
      ttfi:
        interactiveMark && Math.round(interactiveTime - timing.navigationStart),
      dom_processing: timing.domContentLoadedEventEnd - timing.domLoading,
      content_load: timing.loadEventEnd - timing.domContentLoadedEventEnd,
      page_load: timing.loadEventEnd - timing.domLoading,
    },
    (v: number) => (v > 0 ? v : null)
  )
}
